import DoughnutChart from './DoughnutChart'
import FeaturesLightningForm from './FeaturesLightningForm'
import { useAppSelector } from '@/hooks'
import { stateDeviceSelector } from '@/modules/device-module/store/stateSlice'
import { useGetNewUnitQuery } from '@/modules/add-new-unit/services/newUnitService'
import { UnitSearchReq } from '@/modules/devices-list/types/newUnitsType'
import { useGetUnitsHomeMapMutation } from '@/modules/maps/services/homeMapService'
import { useGetUserProfileQuery } from '@/modules/user/services/userService'
import { UserTypes } from '@/types/typeUser'
import { useGetChartsDetectorStatisticsQuery } from './chartsDetectorService'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Box, Theme, Typography, Tooltip } from '@mui/material'
import { getMediaQuery } from '@/utils/getMediaQuery'
import IconChart1 from '@/components/Atoms/Icons/IconChart1'
import IconTrafficJam3 from '@/components/Atoms/Icons/IconTrafficJam3'
import IconTrafficJam4 from '@/components/Atoms/Icons/IconTrafficJam4'
import IconSortingDown from '@/components/Atoms/Icons/IconSortingDown'
import IconSortingUp from '@/components/Atoms/Icons/IconSortingUp'
import IconMaxSpeed from '@/components/Atoms/Icons/IconMaxSpeed'
import IconMinSpeed from '@/components/Atoms/Icons/IconMinSpeed'
import IconAverageSpeed from '@/components/Atoms/Icons/IconAverageSpeed'
import NewCharts from '../chart/NewCharts'

export const sxWrapper = (theme: Theme) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  backgroundColor: '#fff',
  ['.wrapper']: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: '20px',
    padding: '20px 30px 0 50px',
    flexShrink: 0,
    [getMediaQuery(theme, 'desktopLg')]: {
      justifyContent: 'space-around',
      pl: 0,
    },
  },
  ['.graphWrapper']: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    mt: '20px',
    width: 400,
    // minHeight: 420,
    // minWidth: '450px',
    [getMediaQuery(theme, 'desktopLg')]: {
      width: '100%',
      marginBottom: '40px',
    },
  },
  ['.MuiTypography-h4']: {
    color: theme.palette.primary.main,
    textAlign: 'left',
    marginBottom: '20px',
    paddingLeft: '120px',
  },
  ['.row']: {
    display: 'flex',
    flexDirection: 'row',
    gap: '20px',
    color: '#666',
    ['&.speed']: {
      ['.col']: {
        marginBottom: '10px',
        ['&:first-child']: {
          width: '90px',
          justifyContent: 'flex-start',
        },
        ['&:nth-child(2)']: {
          width: '80px',
        },
        ['&:nth-child(3)']: {
          width: '40px',
        },
        ['&:nth-child(4)']: {
          width: '80px',
        },
        ['span']: {
          // minHeight: '40px',
          textAlign: 'center',
          paddingLeft: '0',
          // ['&:first-of-type']: {
          //   color: '#666',
          // },
        },
      },
    },
    ['.col']: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '10px 0',

      ['span']: {
        display: 'inline-block',
        // width: '100%',
        color: '#000',
        paddingLeft: '10px',
      },
      ['&:first-child']: {
        width: '170px',
        justifyContent: 'flex-start',
      },
      ['&:nth-child(2)']: {
        width: '100px',
      },
      ['&:nth-child(3)']: {
        width: '100px',
      },
    },
  },
})

const ChartsDetector = () => {
  const { id } = useParams()
  const { fromDate, toDate } = useAppSelector(stateDeviceSelector)
  const startDate = fromDate.toISOString()
  const endDate = toDate.toISOString()
  const [documents, setDocuments] = useState<any[]>([])
  const { data: currentUserData } = useGetUserProfileQuery('0')
  const currentUserType = currentUserData?.data.typeId
  const {
    data: chartsData,
    isLoading,
    isError,
  } = useGetChartsDetectorStatisticsQuery(
    { deviceId: Number(id), startDate, endDate },
    { skip: !id || Number.isNaN(Number(id)) }
  )
  const stats = chartsData?.success ? chartsData.data : undefined
  // const { data: properties, refetch } = useGetNewUnitQuery(
  //   { id: Number(id) }
  //   // {
  //   //   skip: currentUserType !== UserTypes.superAdmin,
  //   // }
  // )
  const [getDataUnits, { data: units }] = useGetUnitsHomeMapMutation()
  const getLocations = async () => {
    try {
      const usersSearchData: Omit<UnitSearchReq, 'page'> = {
        value: '',
        deviceTypeFilter: [0],
        deviceStateFilter: [0],
        favoriteId: 0,
        lightingTypeId: 0,
      }
      await getDataUnits(usersSearchData).unwrap()
    } catch (e) {
      console.error(e)
    }
  }

  useEffect(() => {
    getLocations()
  }, [])

  // useEffect(() => {
  //   // @ts-ignore
  //   setDocuments(properties?.data?.documents || [])
  // }, [properties])
  return (
    <Box sx={sxWrapper}>
      <Box className={'wrapper'}>
        <Box className={'graphWrapper'}>
          {stats?.totalVehicleCount ? (
            <DoughnutChart
              totalVehicleCount={stats?.totalVehicleCount || 0}
              passengerVehicleCount={stats?.passengerVehicleCount || 0}
              truckVehicleCount={stats?.truckVehicleCount || 0}
              unrecognizedVehicleCount={stats?.unrecognizedVehicleCount || 0}
            />
          ) : (
            <p>Нет данных</p>
          )}
        </Box>
        <Box className={'moveWrapper'}>
          <Typography variant={'h4'}>Движение</Typography>
          <Box className={'row'}>
            <Box className={'col'}></Box>
            <Box className={'col'}>Попутное</Box>
            <Box className={'col'}>Встречное</Box>
          </Box>
          <Box className={'row'}>
            <Box className={'col'}>Обнаружений</Box>
            <Box className={'col'}>
              <IconSortingUp
                width={40}
                height={40}
              />
              <span>{stats?.sameDirectionDetections}</span>
            </Box>
            <Box className={'col'}>
              <IconSortingDown
                width={40}
                height={40}
              />
              <span>{stats?.oppositeDirectionDetections}</span>
            </Box>
          </Box>
          <Box className={'row'}>
            <Box className={'col'}>Время занятости</Box>
            <Box className={'col'}>
              <IconChart1
                width={40}
                height={40}
              />
              <span>{stats?.sameDirectionOccupancyTime}%</span>
            </Box>
            <Box className={'col'}>
              <IconChart1
                width={40}
                height={40}
              />
              <span>{stats?.oppositeDirectionOccupancyTime}%</span>
            </Box>
          </Box>
          <Box className={'row'}>
            <Box className={'col'}>Плотность потока</Box>
            <Box className={'col'}>
              <Tooltip
                title={'авт./км'}
                placement='top'
              >
                <Box
                  display={'flex'}
                  alignItems={'center'}
                >
                  <IconTrafficJam3
                    width={40}
                    height={40}
                  />
                  <span>{stats?.sameDirectionFlowDensity}</span>
                </Box>
              </Tooltip>
            </Box>
            <Box className={'col'}>
              <Tooltip
                title={'авт./км'}
                placement='top'
              >
                <Box
                  display={'flex'}
                  alignItems={'center'}
                >
                  <IconTrafficJam3
                    width={40}
                    height={40}
                  />
                  <span>{stats?.oppositeDirectionFlowDensity}</span>
                </Box>
              </Tooltip>
            </Box>
          </Box>
          <Box className={'row'}>
            <Box className={'col'}>Частота образования заторов</Box>
            <Box className={'col'}>
              <Tooltip
                title={'авт./ч'}
                placement='top'
              >
                <Box
                  display={'flex'}
                  alignItems={'center'}
                >
                  <IconTrafficJam4
                    width={40}
                    height={40}
                  />
                  <span>{stats?.sameDirectionCongestionFrequency}</span>
                </Box>
              </Tooltip>
            </Box>
            <Box className={'col'}>
              <Tooltip
                title={'авт./ч'}
                placement='top'
              >
                <Box
                  display={'flex'}
                  alignItems={'center'}
                >
                  <IconTrafficJam4
                    width={40}
                    height={40}
                  />
                  <span>{stats?.oppositeDirectionCongestionFrequency}</span>
                </Box>
              </Tooltip>
            </Box>
          </Box>
        </Box>
        <Box className={'speedWrapper'}>
          <Typography variant={'h4'}>Скорость</Typography>
          <Box className={'row speed'}>
            <Box className={'col'}></Box>
            <Box className={'col'}>Попутное</Box>
            <Box className={'col'}></Box>
            <Box className={'col'}>Встречное</Box>
          </Box>
          <Box className={'row speed'}>
            <Box className={'col'}>Средняя</Box>
            <Box className={'col'}>
              <span>{stats?.sameDirectionAverageSpeed}</span>
            </Box>
            <Box className={'col'}>
              <Tooltip
                title={'км'}
                placement='top'
              >
                <div>
                  <IconAverageSpeed
                    width={30}
                    height={30}
                  />
                </div>
              </Tooltip>
            </Box>
            <Box className={'col'}>
              <span>{stats?.oppositeDirectionAverageSpeed}</span>
            </Box>
          </Box>
          <Box className={'row speed'}>
            <Box className={'col'}>Минимальная</Box>
            <Box className={'col'}>
              <span>{stats?.sameDirectionMinSpeed}</span>
            </Box>
            <Box className={'col'}>
              <Tooltip
                title={'км'}
                placement='top'
              >
                <div>
                  <IconMinSpeed
                    width={30}
                    height={30}
                  />
                </div>
              </Tooltip>
            </Box>
            <Box className={'col'}>
              <span>{stats?.oppositeDirectionMinSpeed}</span>
            </Box>
          </Box>
          <Box className={'row speed'}>
            <Box className={'col'}>Максимальная</Box>
            <Box className={'col'}>
              <span>{stats?.sameDirectionMaxSpeed}</span>
            </Box>
            <Box className={'col'}>
              <Tooltip
                title={'км'}
                placement='top'
              >
                <div>
                  <IconMaxSpeed
                    width={30}
                    height={30}
                  />
                </div>
              </Tooltip>
            </Box>
            <Box className={'col'}>
              <span>{stats?.oppositeDirectionMaxSpeed}</span>
            </Box>
          </Box>
        </Box>
      </Box>
      <NewCharts />
    </Box>
  )
}

export default ChartsDetector
